module.exports = __webpack_public_path__ + "img/icon-mc_off.20097d4f.png";